<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm4 offset-sm4 pt-5>
        <v-alert  :value="true"  v-if="errorMessage != null" type="error" >{{ errorMessage }}</v-alert>
        <v-layout justify-center column>
          <div v-if="showTroubleshooting == true">
            <v-layout row>
              <v-flex xs12 pt-0 pb-4>
                <h1 >Social sign in trouble Shooting</h1>
            </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pt-0 pb-4>

            <h3 class="notice">Email Permissions</h3>
            <p class="notice">Social registration is dependent on you sharing your email address with the MyStoke service when you create account using your Facebook, Apple ID or Google account.</p>
            <p class="notice">When prompted for permissions during the social regitration, please ensure you allow MyStoke to see your email address.</p>

            <h3 class="notice">Apple ID Sign in</h3>
            <p class="notice">In order to use Apple ID sign in, you must have first created an Apple ID profile within your Apple account. For more information please see <a href="https://appleid.apple.com/account">appleid.apple.com/account</a></p>
            <p class="notice">If your Apple ID is set up correctly, you must also ensure that when you link your Apple ID with this service, that you do not hide personal information. This service requires both first and last names to be passed through in order to complete the account link.</p>
              </v-flex>
            </v-layout>
            </div>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import qs from 'qs'
  export default {
    components: {
      
    },
    data () {
      return {
        errorMessage: null,
        showTroubleshooting: false
      }
    },
    mounted () {
      console.log('Hit AUTH script')
      
      var cognitoCode = this.getQueryVariable('code')
      var redirectURI = process.env.VUE_APP_AWS_COGNITO_AUTH_REDIRECT_URI

      if (window.location.href.includes("referrer=store")) {
        redirectURI += '?referrer=store'
      }else if (window.location.href.includes("referrer=web")) {
         redirectURI += '?referrer=web'
      }

      var bodyParams = {
        grant_type: 'authorization_code',
        client_id : process.env.VUE_APP_AWS_CLIENT_ID,
        redirect_uri : redirectURI,
        code : cognitoCode
      }

      var vm = this

      axios({
        method: 'post',
        url: 'https://'+ process.env.VUE_APP_AWS_COGNITO_AUTH_SERVER +'/oauth2/token',
        data: qs.stringify(bodyParams),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      }).then(function (response) {
        console.log('response', response)


        var accessToken = response.data.access_token
        var idToken = response.data.id_token
        var refreshToken = response.data.refresh_token
        var userSub = vm.$getUserSubFromIdToken(idToken)
        var userPrivacyAccepted = vm.$getUserFieldFromIdToken('custom:privacy_accepted', idToken)
        var secureString = ''
        var expDate = new Date();
        var time = expDate.getTime();
        var expireTime = time + 3600 * 1000 * 24 * 365 //1 year
        expDate.setTime(expireTime)
        

        if(process.env.VUE_APP_COOKIE_SECURE === 'true'){
          secureString = '; secure'
        }

        console.log('cookie set value for VUE_APP_DOMAIN:',process.env.VUE_APP_DOMAIN)
        document.cookie = `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${userSub}.refreshToken=`+ refreshToken+ `; domain=${process.env.VUE_APP_DOMAIN}; path=/${secureString}; expires=${expDate.toGMTString()}`
        document.cookie = `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${userSub}.accessToken=`+ accessToken+ `; domain=${process.env.VUE_APP_DOMAIN}; path=/${secureString}; expires=${expDate.toGMTString()}`
        document.cookie = `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${userSub}.idToken=`+ idToken+ `; domain=${process.env.VUE_APP_DOMAIN}; path=/${secureString}; expires=${expDate.toGMTString()}`
        document.cookie = `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser=`+ userSub + `; domain=${process.env.VUE_APP_DOMAIN}; path=/${secureString}; expires=${expDate.toGMTString()}`
        document.cookie = `CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.clockDrift=0; domain=${process.env.VUE_APP_DOMAIN}; path=/${secureString}; expires=${expDate.toGMTString()}`
        

        //Set Cognito Cookies
        /*vm.$cookie.set(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${userSub}.refreshToken`, refreshToken, {expires: 1, domain: process.env.VUE_APP_DOMAIN, secure: true})
        vm.$cookie.set(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${userSub}.accessToken`, accessToken, {expires: 1, domain: process.env.VUE_APP_DOMAIN, secure: true})
        vm.$cookie.set(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${userSub}.idToken`, idToken, {expires: 1, domain: process.env.VUE_APP_DOMAIN, secure: true})
        vm.$cookie.set(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`, userSub,{expires: 1, domain: process.env.VUE_APP_DOMAIN, secure: true})
        vm.$cookie.set(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.clockDrift`, 0 ,{expires: 1, domain: process.env.VUE_APP_DOMAIN, secure: true})
        */
        
        console.log('cookies set, now redirecting user')
           
        var tokens = {
          'idToken' : idToken,
          'refreshToken' : refreshToken,
          'accessToken' : accessToken
        }

        // mobile app event trigger
        if (typeof window.android !== 'undefined') { 
          window.android.onSignInSuccess(idToken) 
          window.android.passTokens(JSON.stringify(tokens))
        }
        
        if (typeof window.webkit !== 'undefined') { 
          window.webkit.messageHandlers.iOS.postMessage(idToken)
          window.webkit.messageHandlers.iOSTokens.postMessage(JSON.stringify(tokens))
        }

        //Handle Website and Store redirects
        if (window.location.href.includes("referrer=store")) {
          if (userPrivacyAccepted==='true') {
            window.location = process.env.VUE_APP_CLUB_STORE_URL
          } else {
            localStorage.completeRegistrationRedirect = process.env.VUE_APP_CLUB_STORE_URL
            vm.$router.push("/complete-registration/")
          }
        } else if (window.location.href.includes("referrer=web")){
          if (userPrivacyAccepted==='true') {
            window.location = process.env.VUE_APP_CLUB_WEBSITE_URL
          } else {
            localStorage.completeRegistrationRedirect = process.env.VUE_APP_CLUB_WEBSITE_URL
            vm.$router.push("/complete-registration/")
          }
        }else if(localStorage.returnUrl){ // if they were from a trusted referrer and we need to send them back with a JWT
            
          var jwtToken = idToken
          var firstQueryChar = '?' 
          if(localStorage.returnUrl.includes('?')){ // account for ? in string
            firstQueryChar = '&'  
          }
          var redirect = localStorage.returnUrl 
          if(!localStorage.suppressToken){
            redirect = redirect + firstQueryChar + 'token=' + jwtToken
          }
          console.log('redirecting to ' + redirect)
          localStorage.removeItem('returnUrl');
          localStorage.removeItem('suppressToken');
          window.location = redirect
          
        } else if(localStorage.referrer){ // if they were a referral sign in then clear this and redirect them.
          var redirect2 = localStorage.referrer
          console.log('redirecting to ' + redirect2)
          localStorage.removeItem('referrer')
          window.location = redirect2
        }else{
          vm.$router.push("/profile")
        }
      }).catch(function (error) {
        console.log('error',error)
        vm.errorMessage = "Unable to complete social sign in at this time"
        vm.showTroubleshooting = true
        //vm.errorMessage = "Unable to complete social sign in, it is likely that the email address associated with this social platform is already in use with a My Stoke account."
      })
    },
    methods: {
      getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) {
          return decodeURIComponent(pair[1]);
        }
      }
      }
    }
  }
</script>